const filtroBusquedaRCState = {
  loading: false,
  busquedarecargos: false,
  recargosConvenidos: [],
  modalFiltroBusquedaDetalle: false,
  modalShowTecniques: false,
  detailTecniques: {},
  filtrosRecargo: null,
  tipoPrestacionSelected: null,
};

export default filtroBusquedaRCState;




// WEBPACK FOOTER //
// ./src/components/RecargosConvenios/FiltroBusqueda/state.js